import type { RedoLiquidationRpcClient } from "@redotech/redo-merchant-liquidation-rpc/client";
import { createRedoLiquidationRpcClient } from "@redotech/redo-merchant-liquidation-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoLiquidationRpcClientContext: Context<
  RedoLiquidationRpcClient | undefined
> = createContext<RedoLiquidationRpcClient | undefined>(undefined);
RedoLiquidationRpcClientContext.displayName = "RedoLiquidationRpcClientContext";

export function RedoLiquidationRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const redoLiquidationRpcClient = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoLiquidationRpcClient({
      baseURL: new URL(`${baseUrl}/liquidation-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);
  return (
    <RedoLiquidationRpcClientContext.Provider value={redoLiquidationRpcClient}>
      {children}
    </RedoLiquidationRpcClientContext.Provider>
  );
}
